import React from 'react';
import styles from './HatchingModal.module.scss';
import cls from 'classnames';
import Spinner from 'components/Spinner';

export const HatchingModal = () => {
  return (
    <div className={cls('modal fade show', styles.hatchingModal)} tabIndex={-1} id="hatching-modal">
      <div className="modal-backdrop fade show"></div>
      <div className="modal-dialog modal-dialog-centered">
        <div className={cls('modal-content', styles.hatchingModalBody)}>
          <div className={styles.hatchingModalSpinner}>
            <Spinner color="#9075D1" width={52} height={52} />
          </div>
          <p className={cls('subheading-large text-60', styles.hatchingModalTitle)}>
            Hatching your gribble...
          </p>
          <p className={cls('body-large text-60', styles.hatchingModalDescription)}>
            This may take from 30 seconds to 5 minutes.
            <br />
            Please be patient whilst your gribble gets
            <br />
            generated on the blockchain.
          </p>
        </div>
      </div>
    </div>
  );
};
